<template>

  <div id="new" class="main layer2" style="height: calc(100% - 2.5rem); padding-top: 2.5rem; overflow: auto;">
    <top id="top-nav" title="高清视频" :detailType="datailType" ></top>

    <div class="vod-bn">
      <img v-if="title === '每日推荐'" src="../../../assets/images/vod-bn-2.jpg"/>
      <img v-else-if="title === '国产自拍'" src="../../../assets/images/vod-bn-3.jpg"/>
      <img v-else-if="title === '精品热播'" src="../../../assets/images/vod-bn-1.jpg"/>
      <img v-else-if="title === '动漫'" src="../../../assets/images/vod-bn-4.jpg"/>
      <img v-else-if="title === '日本'" src="../../../assets/images/vod-bn-5.jpg"/>
      <img v-else-if="title === '同性欢爱'" src="../../../assets/images/vod-bn-6.jpg"/>
      <img v-else-if="title === '国产传媒'" src="../../../assets/images/vod-bn-13.jpg"/>
      <img v-else-if="title === '中文字幕'" src="../../../assets/images//vod-bn-7.jpg"/>
      <img v-else-if="title === '韩国剧情'" src="../../../assets/images//vod-bn-9.jpg"/>
      <img v-else-if="title === '欧美风情'" src="../../../assets/images/vod-bn-10.jpg"/>
      <img v-else src="../../../assets/images/vod-bn-8.jpg"/>
      <strong>{{ title }}</strong>
    </div>
    <vod-list :show-title="false" :vodData="list"></vod-list>
    <loading ref="loading" scroll-div="new" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="getVodCategory(currentPage + 1)"></loading>
  </div>
</template>

<script>
  import VodList from '@/components/share/vod-list.vue'
  import Loading from "../../../components/share/loading";
  import vodService from "../../../services/vodService";
  import BookTop from '@/components/layer2/book/book-top';

  export default {
    name: "VodCategory",
    data() {
      return {
        componentName: '',
        datailType: 'vod',
        title: '',
        list: [],
        shelvesList: [],
        shelvesListCurrent: [],
        shelvesListTotalPage: 1,
        shelvesListcurrentPage: 1,
        isLoading: false,
        isNoMoreData: false,
        category: 1,
        currentPage: 1,
        pageSize: 10
      }
    },
    watch: {
      '$route': 'gettingData'
    },
    methods: {
      getVodCategory(target) {
        this.currentPage = target;
        if(target === 1 && this.shelvesList) {
          this.list = this.shelvesList
        }
        this.isLoading = true;
        this.isNoMoreData = false;
        vodService.getLatest(this.category, this.currentPage, this.pageSize)
          .then(res => {
            this.isLoading = false;
            //this.shelvesListCurrent = this.shelvesList.slice((this.shelvesListcurrentPage - 1) * 3, this.shelvesListcurrentPage * 3)
            //this.shelvesListcurrentPage = this.shelvesListcurrentPage === this.shelvesListTotalPage ? 1 : this.shelvesListcurrentPage + 1

            if (res.data.totalPage === 0) {
              this.isNoMoreData = true;
              this.list = []
            } else if (this.currentPage === 1) {
              //this.list = this.shelvesListCurrent.concat(res.data.list);
              this.list.push(...res.data.list);
            } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
              //let _list = this.shelvesListCurrent.concat(res.data.list);
              let _list = res.data.list;
              this.list.push(..._list);
            }
            if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
              this.isNoMoreData = true;
            }
            setTimeout(() => {
              this.$refs['loading'].scrollFunction();
            }, 0)
          })
      },
      gettingData(){
        this.category = this.$route.query.cid
      }
    },
    components: {
      'vod-list': VodList,
      loading: Loading,
      top: BookTop
    },
    mounted() {
      this.gettingData();
      switch(parseInt(this.category)){
        case 0:
          this.title = '每日更新'
          break;
        case 1:
          this.title = '每日推荐'
          break;
        case 2:
          this.title = '国产自拍'
          break;
        case 3:
          this.title = '精品热播'
          break;
        case 4:
          this.title = '国产传媒'
          break;
        case 5:
          this.title = '日本'
          break;
        case 6:
          this.title = '中文字幕'
          break;
        case 7:
          this.title = '同性欢爱'
          break;
        case 8:
          this.title = '动漫'
          break;
        case 9:
          this.title = '韩国剧情'
          break;
        case 10:
          this.title = '欧美风情'
          break;
      }
      // if(this.category !== '0'){
      //   this.pageSize = 7
      //   this.shelvesList = JSON.parse(window.localStorage.getItem("shelves" + this.category))
      //   this.shelvesListTotalPage = Math.floor(this.shelvesList.length / 3)
      // }
      this.shelvesList = JSON.parse(window.localStorage.getItem("shelves" + this.category))
      this.componentName = this.$route.name;
      if(this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('new');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 0);
      }
      else {
        this.getVodCategory(1);
      }
      this.$router.isBack = true;
    },
    beforeDestroy() {
      let scrollDiv = document.getElementById('new');
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      this.$store.commit('saveState', state);
    }


  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/layer2/vod/category.vue